export default __webpack_public_path__ + "static/media/dapperLOGO.b212a69e.png";